import React, { useState, useEffect } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import { BiErrorCircle } from 'react-icons/bi';

const ToastNotification = ({ message, type = 'error', duration = 5000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        onClose && onClose();
      }, 300); // Wait for the animation to complete before removing
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const getToastStyles = () => {
    switch (type) {
      case 'success':
        return {
          backgroundColor: '#e8f5e9',
          borderLeft: '4px solid #4caf50',
          color: '#2e7d32',
          icon: <BiErrorCircle size={20} color="#4caf50" />
        };
      case 'info':
        return {
          backgroundColor: '#e3f2fd',
          borderLeft: '4px solid #2196f3',
          color: '#0d47a1',
          icon: <BiErrorCircle size={20} color="#2196f3" />
        };
      case 'warning':
        return {
          backgroundColor: '#fff8e1',
          borderLeft: '4px solid #ff9800',
          color: '#ef6c00',
          icon: <BiErrorCircle size={20} color="#ff9800" />
        };
      case 'error':
      default:
        return {
          backgroundColor: '#ffebee',
          borderLeft: '4px solid #f44336',
          color: '#c62828',
          icon: <BiErrorCircle size={20} color="#f44336" />
        };
    }
  };

  const toastStyles = getToastStyles();

  return (
    <div 
      className={`toast-notification ${isVisible ? 'visible' : 'hidden'}`}
      style={{
        position: 'fixed',
        top: '20px', // Changed from 'bottom' to 'top'
        right: '20px',
        maxWidth: '350px',
        backgroundColor: toastStyles.backgroundColor,
        borderLeft: toastStyles.borderLeft,
        color: toastStyles.color,
        padding: '12px 16px',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transform: isVisible ? 'translateX(0)' : 'translateX(120%)',
        transition: 'transform 0.3s ease-in-out',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={{ marginRight: '12px' }}>
          {toastStyles.icon}
        </div>
        <div style={{ fontSize: '14px' }}>{message}</div>
      </div>
      <button 
        onClick={() => {
          setIsVisible(false);
          setTimeout(() => onClose && onClose(), 300);
        }}
        style={{
          background: 'none',
          border: 'none',
          color: toastStyles.color,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          padding: '0',
          marginLeft: '12px',
        }}
      >
        <IoCloseOutline size={20} />
      </button>
    </div>
  );
};

export default ToastNotification;